import { Injectable } from "@angular/core";
import { DefaultUrlSerializer, UrlTree } from "@angular/router";

const LEGACY_PAGE_PARAM = "page";
const PAGE_INDEX_PARAM = "pageIndex";
const NUMERIC_PAGE_PATTERN = /^\d+$/;

@Injectable()
export class LegacyPageQueryUrlSerializer extends DefaultUrlSerializer {
  override parse(url: string): UrlTree {
    const tree = super.parse(url);
    const { [LEGACY_PAGE_PARAM]: legacyPage, ...queryParams } = tree.queryParams;

    if (!NUMERIC_PAGE_PATTERN.test(legacyPage ?? "")) {
      return tree;
    }

    tree.queryParams = { ...queryParams, [PAGE_INDEX_PARAM]: queryParams[PAGE_INDEX_PARAM] ?? legacyPage };

    return tree;
  }
}
